// Third-party packages
import {
	PATHS,
} from '@routes/paths';
import {
	lazy,
} from 'react';

// LAZY LOADING
const TabReport = lazy(() =>
	import('@layouts/Pages/PageDemand/report').then((module) => ({
		default: module.Report,
	})),
);
const TabManage = lazy(() =>
	import('@layouts/Pages/PageDemand/manage').then((module) => ({
		default: module.Manage,
	})),
);

export const DEMAND_MANAGE_ROUTES = [
	{
		element: <TabManage />,
		path: PATHS.DEMANDS.PRIVATE.MANAGE._ROOT,
	},
	{
		element: <TabManage />,
		path: PATHS.DEMANDS.PRIVATE.MANAGE.STEP._ROOT,
	},
	{
		element: <TabManage />,
		path: PATHS.DEMANDS.PRIVATE.MANAGE.STEP.OFFER._ROOT,
	},
];
export const DEMAND_ROUTES = [
	...DEMAND_MANAGE_ROUTES,
	{
		element: <TabReport />,
		path: PATHS.DEMANDS.PRIVATE.REPORT,
	},
];
